<template>
  <div class="">
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/ylts/home">医疗特色</router-link> >
      <router-link to="/ylts/mingyi">盛京名医</router-link> >
      {{ content.name }}
    </div>
    <div class="container-width mt50 mb50">
      <div class="title">{{ content.name }}</div>
      <!-- <div class="description" v-html="content.description"></div> -->
      <div class="d-department">[相关医生]</div>
      <div class="d-list doctor_swiper">
        <div class="swiper-wrapper">
          <div
            class="d-item swiper-slide"
            v-for="(item, index) in doctorListData"
            :key="index"
          >
            <div class="d-avatar" @click="godoctor(item.id)">
              <img :src="item.url" />
              <div class="d-description">
                <p class="multi-ellipsis">{{ item.description }}</p>
              </div>
            </div>
            <div class="d-name" @click="godoctor(item.id)">
              <span>「 {{ item.zhicheng }} 」</span><br />
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="container-width swiper_control">
        <ul class="clearFix">
          <li class="fl"><span></span></li>
          <li class="fr"><span></span></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/ylts";
import config from "../../config/dev";
import BANNER from "../../components/banner/ylts";
export default {
  name: "KEARTICLE",
  data() {
    return {
      navigationData: [
      {
          name: "科室介绍",
          path: "/ylts/home",
          width: "31%",
        },
        {
          name: "盛京名医",
          path: "/ylts/mingyi",
          width: "31%",
        },
        {
          name: "国家临床重点专科",
          path: "/ylts/zhuanke",
          width: "38%",
        },
        {
          name: "特色医疗中心",
          path: "/ylts/tese",
        },
        {
          name: "护理专业发展",
          path: "/ylts/huli",
        },
      ],
      currentPath: "/ylts/mingyi",
      id: 0,
      content: {},
      doctorListData: [],
      showAll: false,
      maleImg: require("../../assets/image/male.png"),
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.id = this.$route.params.id;
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.id,
      };
      service.getDepartmentInfo(parmes, (res) => {
        this.content = { ...res };
      });
      let parmes2 = {
        pageIndex: 1,
        pageSize: 200,
        departId: this.id,
      };
      service.getArcDocList(parmes2, (res) => {
        if (res.length) {
          res.map((item) => {
            item.url = item.url
              ? config.url +
                "/file/downloadFile/" +
                item.url +
                "?isDownload=true"
              : this.maleImg;
            item.description = item.description
              ? item.description
                  .replace(/<[^>]+>/g, "")
                  .replace("专业特长：", "")
                  .trim()
              : "";
          });
        }
        this.doctorListData = res || [];
        this.$nextTick(() => {
          this.myswiper();
        });
      });
    },
    changeShow() {
      this.showAll = !this.showAll;
    },
    godoctor(id) {
      this.changeData = !this.changeData;
      let articleId = id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/doctor/${articleId}`,
      });
      window.open(href, "_blank");
    },
    myswiper() {
      var SwiperImg;
      if (window.screen.width < 560) {
        var SwiperImg = new Swiper(".doctor_swiper", {
          slidesPerView: "2",
          mode: "horizontal",
          slidesPerGroup: 2,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".fr",
            prevEl: ".fl",
          },
        });
      } else if (window.screen.width > 561 && window.screen.width <= 728) {
        var SwiperImg = new Swiper(".doctor_swiper", {
          slidesPerView: "3",
          mode: "horizontal",
          slidesPerGroup: 4,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".fr",
            prevEl: ".fl",
          },
        });
      } else {
        var SwiperImg = new Swiper(".doctor_swiper", {
          slidesPerView: "8",
          mode: "horizontal",
          slidesPerGroup: 6,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".fr",
            prevEl: ".fl",
          },
        });
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>


<style scoped lang="scss">
.title {
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 2rem;
}
.description {
  line-height: 40px;
  font-size: 1.2rem;
}
.d-department {
  color: #00479d;
  font-size: 1.4rem;
  cursor: pointer;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #e5f5ff;
  padding: 5px 20px 5px 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 30px;
}

.d-list {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  .d-item {
    width: 205px;
    margin-right: 15px;
    //height: 382px;/* 显示6个的时候 */
    overflow: hidden;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    cursor: pointer;
    .d-avatar {
      position: relative;
      // height: 342px; /* 显示6个的时候 */
      // width: 205px; /* 显示6个的时候 */
      img {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        max-width: 100%; /* 显示6个的时候 */
        height: 206px; /* 显示6个的时候 */
        overflow: hidden;
      }
      .d-description {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: url(../../assets/image/mask40.png);
        text-align: center;
        color: #fff;
        line-height: 24px;
        font-size: 14px;
        overflow: hidden;
        padding: 10px 20px;
        box-sizing: border-box;
        height: 70px;
      }
    }
    .d-name {
      height: 40px;
      flex: 1;
      span {
        font-size: 12px;
        color: #333;
      }
    }
  }
}
.swiper_control ul li:first-child {
  margin-right: 10px;
}
.swiper_control ul li:last-child {
  margin-left: 10px;
  margin-right: 0px;
}
</style>
